import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { FadeUp, Eyebrow } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (!res.ok) throw new Error("failed");
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <section className="bg-blush border-t border-petal/15 py-16 lg:py-20 grain relative" data-testid="newsletter-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
        <FadeUp>
          <Eyebrow>The sisterhood letters</Eyebrow>
          <h2 className="mt-4 font-serif font-semibold text-ink text-3xl lg:text-4xl leading-tight">
            New country chapters, straight to your inbox.
          </h2>
          <p className="mt-4 text-sage leading-relaxed max-w-xl mx-auto">
            When a new destination profile, checklist, or honest take goes live, you'll be the first to know. No spam — just sisterhood. Unsubscribe anytime.
          </p>
          {state === "done" ? (
            <div data-testid="newsletter-success" className="mt-8 inline-flex items-center gap-2.5 bg-pine text-cream px-6 py-4 rounded-full font-semibold text-sm">
              <Check size={16} className="text-petal-soft" /> MashaAllah — you're in the sisterhood letters!
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
              <label htmlFor="newsletter-email" className="sr-only">Email address</label>
              <input
                id="newsletter-email"
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => { setEmail(e.target.value); if (state === "error") setState("idle"); }}
                placeholder="you@example.com"
                className="flex-1 bg-white border border-pine/15 rounded-full px-5 py-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-petal/40"
              />
              <button
                type="submit"
                data-testid="newsletter-submit-btn"
                disabled={state === "loading"}
                className="inline-flex items-center justify-center gap-2 bg-petal text-white text-sm font-semibold px-6 py-3.5 rounded-full shadow-md shadow-petal/25 hover:bg-pine transition-colors disabled:opacity-60"
              >
                <Mail size={15} /> {state === "loading" ? "Joining..." : "Join the letters"}
              </button>
            </form>
          )}
          {state === "error" && (
            <p data-testid="newsletter-error" className="mt-3 text-sm text-petal-dark font-medium">
              Something went wrong, sis — please try again.
            </p>
          )}
        </FadeUp>
      </div>
    </section>
  );
};
